import React from 'react'
import styles from './styles.scss'

const Input = props => (
  <input
    className={styles['wrapper-input']}
    {...props}
  />
)

export default Input


// WEBPACK FOOTER //
// ./src/components/Input/index.js